type AnonymizeLawTopicItemTitleProps = {
  title: string
  forceSkip?: boolean
}

export const anonymizeLawTopicItemTitle = (props: AnonymizeLawTopicItemTitleProps) => {
  const { title, forceSkip = true } = props
  const allowedToken = [
    'art.',
    'lei',
    'código',
    'nº',
    'n.',
    'do',
    'da',
    'de',
    'súmula',
    'precedente',
    'obrigatório:',
  ]

  if (forceSkip) {
    return title
  }

  return title
    .split(/\s/)
    .map((token) => {
      if (allowedToken.includes(token.toLowerCase())) return token
      return token.replace(/[A-Za-zÀ-ÿ0-9]/g, 'x')
    })
    .join(' ')
}
